var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('JobTable',{attrs:{"jobs":_vm.jobs},on:{"remove-job":function($event){_vm.onRemoveJob($event)},"clone-job":_vm.fetchJobs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }